var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-secondary mx-auto my-1x",staticStyle:{"height":"1em","width":"1px","opacity":"0.6"}})}
var staticRenderFns = []

export { render, staticRenderFns }